import { useFeatureFlagContext } from "@/core/config/feature-flags/FeatureFlagProvider"

export const useFeatureFlag = (key: string): boolean => {
  const { isEnabled } = useFeatureFlagContext()
  return isEnabled(key)
}
